module.exports = __webpack_public_path__ + "static/media/frame5.e70ab6f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-bottom/frame5.png
// module id = 78
// module chunks = 0